import { ItemSearchReturnResponse } from 'app/services/itemsSearchService';
import { DialogFormData } from 'common/receipt.types';

export const useIsEditMode = (
  toBeDetermined: ItemSearchReturnResponse | DialogFormData | null,
): toBeDetermined is DialogFormData => {
  if (toBeDetermined !== null) {
    return !!(toBeDetermined as DialogFormData).unitPrice;
  }
  return false;
};
